<script>
	import "bootstrap-vue/dist/bootstrap-vue.css";
	import pagination from "vue-bootstrap-pagination";
	import courseListView from "./CourseListView.vue";
	import leftSideBar from "./LeftSideBar.vue";

	import * as mixin from "../secret/CryptoMaxin.vue";
	import * as detectMobileMixin from "../shared/detect-mobile-mixin.vue";
	import * as detectIEMixin from "../shared/detect-ie-mixin.vue";
	import * as CryptoJS from "crypto-js";

	export default {
		mixins: [mixin, detectMobileMixin, detectIEMixin],
		components: {
			pagination,
			"course-list-view": courseListView,
			"left-side-bar": leftSideBar
		},
		props: {
			category: {
				type: String,
				default: "govtbc"
			},
			showLevel: {
				type: Boolean,
				default: true
			},
			showFinanceType: {
				type: Boolean,
				default: true
			},
			showMode: {
				type: Boolean,
				default: true
			},
			showArea: {
				type: Boolean,
				default: true
			},
			showAward: {
				type: Boolean,
				default: true
			},
			keyword: {
				type: String,
				default: ""
			}
		},
		watch: {
			finishInit: {
				handler: function(val) {
					if (val) {
						this.loadedKey();
					}
				}
			},
			sortedBy: {
				handler: function(n, o) {}
			}
		},
		data() {
			return {
				mobile: false,
				display: "LIST",
				sessionKeys: {
					display: "course-display",
					filter: "course-filter",
					course: "course-s"
				},
				sortedBy: null,
				showSideMenu: true,
				perPage: 20,
				total: 0,
				currentPage: 1,
				pagedItems: [],
				courses: [],
				courseIndexLink: "",
				filteredItems: [],
				loading: false,
				institutions: [],
				levels: [],
				modes: [],
				areas: [],
				awards: [],
				financeTypes: [],
				cachedPage: 1,
				isRestoreCache: false,
				filterMsg: "",
				isScrolling: false,
				model: {
					institutions: {},
					levels: {},
					modes: {},
					areas: {},
					awards: {},
					financeTypes: {},
					keyword: ""
				},
				sortSeq: {
					institution: "asc",
					programme_name: "asc",
					area_of_study: "asc",
					mode: "asc"
				}
			};
		},
		mounted() {
			this.$nextTick(() => {
				window.addEventListener("resize", () => {
					this.checkIsMobile();
				});
			});
			this.checkIsMobile();
			this.alertIE();
			this.loading = true;
			this.courseIndexLink = "/course";

			this.super();
		},
		methods: {
			checkIsMobile() {
				this.mobile = this.isMobile();
				this.showSideMenu = !this.mobile;
			},
			initKeys() {
				this.sessionKeys.display = `course-${this.category}-display`;
				this.sessionKeys.filter = `course-${this.category}-filter`;
				this.sessionKeys.course = `course-${this.category}-s`;
			},
			loadedKey() {
				this.initKeys();

				let self = this;
				let sd = sessionStorage.getItem(this.sessionKeys.display);
				if (sd != null) this.display = sd;
				let cacheItems = sessionStorage.getItem(this.sessionKeys.course);

				if (cacheItems) {
					this.decrypt_data(
						new Uint16Array(self.base64ToArrayBuffer(cacheItems))
					).then(
						function(result) {
							let decryptedData = self.convertArrayBufferViewtoString(
								new Uint16Array(result)
							);
							let tmp = JSON.parse(decryptedData);
							self.isRestoreCache = tmp.category == self.category;
							if (self.isRestoreCache) {
								self.model = tmp.model;
								self.courses = tmp.courses;
								self.levels = tmp.levels;
								self.modes = tmp.modes;
								self.areas = tmp.areas;
								self.awards = tmp.awards;
								self.financeTypes = tmp.financeTypes;
								self.institutions = tmp.institutions;
								self.cachedPage = tmp.current_page;
								self.init();
							} else {
								self.fetchData();
							}
						},
						function(e) {
							self.fetchData();
						}
					);
				} else {
					self.fetchData();
				}
			},
			fetchData() {
				this.isRestoreCache = false;
				axios.get(`/api/course/getCourses/${this.category}`).then(res => {
					this.courses = res.data.data;
					this.levels = res.data.metadata.levels;
					this.modes = res.data.metadata.modes;
					this.areas = res.data.metadata.areas;
					this.awards = res.data.metadata.awards;
					this.financeTypes = res.data.metadata.financeTypes;
					this.institutions = res.data.metadata.institutions;

					this.init();
				}).catch(err => {
					console.error('[CourseListMixin] API error:', err);
				});
			},
			storeStatus(target) {
				let self = this;
				if (target == "courses") {
					let data = {
						category: this.category,
						model: this.model,
						current_page: this.currentPage,
						levels: this.levels,
						modes: this.modes,
						areas: this.areas,
						awards: this.awards,
						financeTypes: this.financeTypes,
						institutions: this.institutions,
						courses: this.courses,
						create_datetime: moment()
					};
					data = JSON.stringify(data);
					this.encrypt_data(data).then(
						function(result) {
							let encryptedData = new Uint16Array(result);
							var base64Data = self.arrayBufferToBase64(result);
							sessionStorage.setItem(self.sessionKeys.course, base64Data);
						},
						function(e) {
							console.log(e.message);
						}
					);
				}
			},
			refresh() {
				this.fetchData();
				this.reset();
			},
			reset() {
				sessionStorage.removeItem(this.sessionKeys.filter);
				this.prepareFilters();
				this.model = {
					institutions: {},
					levels: {},
					modes: {},
					areas: {},
					awards: {},
					financeTypes: {},
					keyword: ""
				};
				this.filter();
				this.storeStatus("filter");
			},
			prepareFilters() {
				this.institutions.forEach(item => {
					this.model.institutions[item] = false;
				});
				this.model.institutions = Object.assign({}, this.model.institutions);

				this.levels.forEach(item => {
					this.model.levels[item] = false;
				});
				this.model.levels = Object.assign({}, this.model.levels);

				this.modes.forEach(item => {
					this.model.modes[item] = false;
				});
				this.model.modes = Object.assign({}, this.model.modes);

				this.areas.forEach(item => {
					this.model.areas[item] = false;
				});
				this.model.areas = Object.assign({}, this.model.areas);

				this.awards.forEach(item => {
					this.model.awards[item] = false;
				});
				this.model.awards = Object.assign({}, this.model.awards);

				this.financeTypes.forEach(item => {
					this.model.financeTypes[item] = false;
				});
				this.model.financeTypes = Object.assign({}, this.model.financeTypes);

				if (this.keyword) {
					this.model.keyword = this.keyword;
				}
			},
			init() {
				this.filteredItems = this.courses;
				this.filteredItems = _.orderBy(this.filteredItems, ["institution"], ["asc"]);

				let sFilter = sessionStorage.getItem(this.sessionKeys.filter);
				if (sFilter != null && this.isRestoreCache) {
					sFilter = JSON.parse(sFilter);
					this.model = sFilter.filters;
					this.settleParams();
					this.filter();
					this.setPage(this.cachedPage, false);
					this.currentPage = this.cachedPage;
				} else {
					this.prepareFilters();
					this.settleParams();
					this.filter();
					this.currentPage = 1;
					this.setPage(1, false);
				}
			},
			orderBy(col) {
				let sortSeq = this.sortSeq[col] == "asc" ? "desc" : "asc";
				this.sortSeq[col] = sortSeq;
				let temp = _.orderBy(this.filteredItems, col, this.sortSeq[col]);
				this.filteredItems = temp;
				this.currentPage = 1;
				this.setPage(1);
			},
			changeSortDirection(direction) {
				if (this.sortedBy) {
					let temp = _.orderBy(this.filteredItems, this.sortedBy, direction);
					this.filteredItems = temp;
					this.setPage(1);
				}
			},
			setSortFromView(col, direction) {
				this.sortedBy = col;
				this.sortSeq[col] = direction;
				let temp = _.orderBy(this.filteredItems, col, direction);
				this.filteredItems = temp;
				this.currentPage = 1;
				this.setPage(1);
			},
			settleParams() {
				if (this.keyword != "") {
					this.model.keyword = this.keyword;
				}
			},
			filter() {
				this.filterMsg = "";
				let temp = this.courses;

				if (this.model.keyword) {
					if (this.filterMsg.indexOf(this.model.keyword) == -1) {
						this.filterMsg += ` ${this.model.keyword} `;
					}

					let keyword = this.model.keyword;
					var options = {
						shouldSort: true,
						findAllMatches: true,
						threshold: 0.3,
						location: 0,
						distance: 100,
						maxPatternLength: 100,
						minMatchCharLength: 1,
						keys: ["programme_name", "institution", "area_of_study", "award"]
					};
					var fuse = new Fuse(temp, options);
					temp = fuse.search(keyword);
				}

				if (this.isModified("institutions")) {
					temp = temp.filter(c => {
						if (this.model.institutions[c.institution]) {
							return true;
						}
					});
					for (let idx in this.model.institutions) {
						if (this.model.institutions[idx] && this.filterMsg.indexOf(idx) == -1)
							this.filterMsg += ` ${idx} `;
					}
				}

				if (this.isModified("levels")) {
					temp = temp.filter(c => {
						if (this.model.levels[c.level]) {
							return true;
						}
					});
					for (let idx in this.model.levels) {
						if (this.model.levels[idx] && this.filterMsg.indexOf(idx) == -1)
							this.filterMsg += ` ${idx} `;
					}
				}

				if (this.isModified("modes")) {
					temp = temp.filter(c => {
						if (this.model.modes[c.mode]) {
							return true;
						}
					});
					for (let idx in this.model.modes) {
						if (this.model.modes[idx] && this.filterMsg.indexOf(idx) == -1)
							this.filterMsg += ` ${idx} `;
					}
				}

				if (this.isModified("areas")) {
					temp = temp.filter(c => {
						if (this.model.areas[c.area_of_study]) {
							return true;
						}
					});
					for (let idx in this.model.areas) {
						if (this.model.areas[idx] && this.filterMsg.indexOf(idx) == -1)
							this.filterMsg += ` ${idx} `;
					}
				}

				if (this.isModified("awards")) {
					temp = temp.filter(c => {
						if (this.model.awards[c.award]) {
							return true;
						}
					});
					for (let idx in this.model.awards) {
						if (this.model.awards[idx] && this.filterMsg.indexOf(idx) == -1)
							this.filterMsg += ` ${idx} `;
					}
				}

				temp = _.orderBy(temp, ["institution"], ["asc"]);

				this.filteredItems = temp;

				this.storeStatus("filter");

				this.currentPage = 1;
				this.setPage(1, false);
			},
			isModified(col) {
				let modified = false;
				Object.keys(this.model[col]).forEach(prop => {
					if (this.model[col][prop]) modified = true;
				});
				return modified;
			},
			goTop(scroll = true) {
				if (!scroll) return;
				const header = document.querySelector('.course-list-header');
				if (header) {
					const top = header.offsetTop - 80;
					window.scrollTo({ top: top, behavior: 'smooth' });
				} else {
					window.scrollTo({ top: 0, behavior: 'smooth' });
				}
			},
			setPage(page, scroll = true) {
				this.loading = false;
				this.goTop(scroll);

				if (!page) {
					page = this.currentPage;
				}

				if (page < 1) {
					page = 1;
				}

				let pagination = this.getPager(
					this.filteredItems.length,
					page,
					this.perPage
				);

				if (pagination.totalPages > 0 && page > pagination.totalPages) {
					page = pagination.totalPages;
					pagination = this.getPager(
						this.filteredItems.length,
						page,
						this.perPage
					);
				}

				this.total = pagination.total;
				this.currentPage = pagination.current_page;

				this.pagedItems = this.filteredItems.slice(
					pagination.from,
					pagination.to
				);
			},
			getPager(totalItems, currentPage = 1, pageSize = 10) {
				let totalPages = Math.ceil(totalItems / pageSize);

				let from = 0, to = 0;

				from = currentPage * pageSize - pageSize;
				let remaining = totalItems % pageSize;

				if (currentPage == totalPages) {
					remaining > 0 ? (to = from + remaining) : (to = currentPage * pageSize);
				} else {
					to = currentPage * pageSize;
				}

				let pages = _.range(1, totalPages + 1);
				return {
					total: totalItems,
					current_page: currentPage,
					per_page: pageSize,
					totalPages: totalPages,
					from: from,
					to: to,
					startPage: currentPage,
					last_page: totalPages,
					pages: pages
				};
			}
		}
	};
</script>



// WEBPACK FOOTER //
// resources/js/course_new/CourseListMixin.vue